import React from "react"

import { SendForSignatureButton } from "../../../Esign/components/SendForSignatureButton.tsx"
import { useSendForSignature } from "../../../Esign/hooks/use-send-for-signature.ts"
import { type LeadAttachment } from "../../types/lead.types.ts"
import { type LeadPatchSender } from "../lead-workspace-patch.ts"
import { LeadAttachmentsCard } from "./LeadAttachmentsCard.tsx"

interface LeadFilesTabProps {
  leadId?: string
  attachments?: LeadAttachment[] | null
  canEdit?: boolean
  saving?: boolean
  onPatch: LeadPatchSender
}

/**
 * Split out of Additional Info (2026-08-30): documents/images/files get
 * their own tab instead of sharing a card grid with qualification and the
 * checklist.
 */
function LeadFilesTab({
  leadId,
  attachments,
  canEdit,
  saving,
  onPatch
}: LeadFilesTabProps) {
  const sendForSignature = useSendForSignature(leadId)

  return (
    <div data-testid={"lead-files"}>
      <LeadAttachmentsCard
        attachments={attachments}
        canEdit={canEdit}
        saving={saving}
        onPatch={onPatch}
        headerActions={<SendForSignatureButton leadId={leadId} />}
        onSendForSignature={
          sendForSignature
            ? (file) => sendForSignature({ type: "attachment", id: file.id })
            : undefined
        }
      />
    </div>
  )
}

export { LeadFilesTab }
